import React from "react";
import { ContextState } from "./types";
import { useDragLayer } from "react-dnd";

const Context = React.createContext<ContextState>({
  currentPriority: 0,
  setState: () => {},
});

function useContext() {
  const { data, isDragging } = useDragLayer((monitor) => ({
    data: monitor.getItem() || {
      type: "NULL",
      payload: {},
    },
    isDragging: monitor.isDragging(),
  }));
  const { currentPriority, setState } = React.useContext(Context);

  return {
    data,
    isDragging,
    currentPriority,
    setState,
  };
}

export { Context, useContext };
